import React, { createRef, Component } from 'react'
import FlexView from 'react-flexview/lib'
import { Button, Tooltip, Grid, Paper, FormLabel } from '@material-ui/core'
import Dropzone from 'react-dropzone'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import { isMobile } from 'react-device-detect'
import CheckIcon from '@material-ui/icons/Check'
import CloseIcon from '@material-ui/icons/Close'
import FileCopyIcon from '@material-ui/icons/FileCopy'
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile'
import './FileUpload.scss'
import NewFillButton from './NewFillButton'
import { GreenButton } from './Buttons/GreenButton'
import { LinearProgressWithLabel } from './LinearProgressWithLabel'
import { SkyPaper } from './Frames/SkyPaper'
import { FileItemView } from './FileUpload'
import { BlueGrayBox } from './BlueGrayBox'
import './SkywatchDropzone.scss'

type FileUploadProps = {
    uploadEnabled: Boolean,
    accept: String,
    placeholder: Component,
}

export default class SkywatchDropzone extends React.Component {
    props: FileUploadProps
    constructor(props) {
        super(props)
        this.state = {
            files: [],
        }
    }

    dropzone = createRef()

    onFileDrop = (files) => {
        var filesToAdd = []
        for (var i = 0; i < files.length; i++) {
            if (!this.state.files.find((f) => f.name == files[i].name))
                filesToAdd.push(files[i])
        }
        this.setState({ files: [...this.state.files, ...filesToAdd] })
        this.onFileSelected(filesToAdd)
    }

    getFiles = () => {
        return this.state.files
    }

    onRemoveFile = (index) => {
        this.setState({
            files: [
                ...this.state.files.slice(0, index),
                ...this.state.files.slice(index + 1),
            ],
        })
    }

    onFileSelected = (files) => {
        this.props.onFileSelected && this.props.onFileSelected(files)
    }

    openFileUpload = () => this.dropzone.open()

    render() {
        return (
            <FlexView column>
                <BlueGrayBox className="skydropzone">
                    <Dropzone
                        ref={(ref) => (this.dropzone = ref)}
                        multiple
                        accept={this.props.accept}
                        onDrop={this.onFileDrop}
                    >
                        {({ getRootProps, getInputProps }) => (
                            <>
                                <section className="clickable margin-top-small">
                                    <div {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        {this.props.placeholder}
                                        <br />
                                        {this.state.files.length > 0 && (
                                            <Grid spacing={1} container>
                                                {this.state.files.map(
                                                    (item, index) => (
                                                        <Grid item key={index}>
                                                            <FileItemView
                                                                key={index}
                                                                remove={(e) => {
                                                                    e.stopPropagation()
                                                                    this.onRemoveFile(
                                                                        index
                                                                    )
                                                                }}
                                                                file={item}
                                                            />
                                                        </Grid>
                                                    )
                                                )}
                                            </Grid>
                                        )}
                                        <br />
                                    </div>
                                </section>
                            </>
                        )}
                    </Dropzone>
                </BlueGrayBox>
                <FormLabel className="margin-top-6" error={!!this.props.error}>
                    {this.props.error}
                </FormLabel>
            </FlexView>
        )
    }
}
